// tslint:disable
export enum StagingDocumentType {
    /**
     * @description 
     */
    UNKN = 0,
    /**
     * @description 
     */
    SRF = 1,
    /**
     * @description 
     */
    COR = 2,
    /**
     * @description 
     */
    INC = 3,
    /**
     * @description 
     */
    CLM = 4,
    /**
     * @description 
     */
    ENR = 5,
    /**
     * @description 
     */
    PA = 6,
    /**
     * @description 
     */
    AOB = 7,
    /**
     * @description 
     */
    OTHER = 8,
}
